import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import classNames from '../../node_modules/classnames/index.js';

var CListGroup = forwardRef(function (_a, ref) {
    var _b;
    var children = _a.children, _c = _a.as, Component = _c === void 0 ? 'ul' : _c, className = _a.className, flush = _a.flush, layout = _a.layout;
    return (React.createElement(Component, { className: classNames('list-group', (_b = {
                'list-group-flush': flush
            },
            _b["list-group-".concat(layout)] = layout,
            _b), className), ref: ref }, children));
});
CListGroup.propTypes = {
    as: PropTypes.elementType,
    children: PropTypes.node,
    className: PropTypes.string,
    flush: PropTypes.bool,
    layout: PropTypes.oneOf([
        'horizontal',
        'horizontal-sm',
        'horizontal-md',
        'horizontal-lg',
        'horizontal-xl',
        'horizontal-xxl',
    ]),
};
CListGroup.displayName = 'CListGroup';

export { CListGroup };
//# sourceMappingURL=CListGroup.js.map
